
const digest = '734b9ee3b1de88369d055b216e044d8d62f42dc4aeeed4b7db31020b99ff0694';
const classes = {"wrapper":"_wrapper_u64sz_1","disabled":"_disabled_u64sz_14","haveToFillNow":"_haveToFillNow_u64sz_18","extra":"_extra_u64sz_21","scheduled":"_scheduled_u64sz_26","prescheduled":"_prescheduled_u64sz_26","cantFillNow":"_cantFillNow_u64sz_34","canFillNow":"_canFillNow_u64sz_42","completed":"_completed_u64sz_50"};
const css = `._wrapper_u64sz_1 {
  width: 40px;
  height: 20px;
  border-radius: 4px;
  margin: 4px 0;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
}

._disabled_u64sz_14 {
  cursor: default;
}

._haveToFillNow_u64sz_18 {
  background: rgb(170, 15, 40);
}
._haveToFillNow_u64sz_18._extra_u64sz_21 {
  color: rgb(170, 15, 40);
  background: rgba(170, 15, 40, 0.3);
}

._scheduled_u64sz_26, ._prescheduled_u64sz_26 {
  background: rgb(22, 101, 216);
}
._scheduled_u64sz_26._extra_u64sz_21, ._prescheduled_u64sz_26._extra_u64sz_21 {
  color: rgb(22, 101, 216);
  background: rgba(22, 101, 216, 0.3);
}

._cantFillNow_u64sz_34 {
  background: rgb(98, 98, 98);
}
._cantFillNow_u64sz_34._extra_u64sz_21 {
  color: rgb(98, 98, 98);
  background: rgba(98, 98, 98, 0.3);
}

._canFillNow_u64sz_42 {
  background: rgb(225, 94, 0);
}
._canFillNow_u64sz_42._extra_u64sz_21 {
  color: rgb(225, 94, 0);
  background: rgba(225, 94, 0, 0.3);
}

._completed_u64sz_50 {
  background: rgb(65, 154, 13);
}
._completed_u64sz_50._extra_u64sz_21 {
  color: rgb(65, 154, 13);
  background: rgba(65, 154, 13, 0.3);
}

._disabled_u64sz_14 {
  cursor: not-allowed;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  